<mat-card class="header-card">
  <mat-card-content>
    <div class="cover-image"></div>
    <div class="profile-info">
      <img class="profile-img" src="./assets/img/profil.png" alt="Profilbild" />
      <h2>{{ user.firstName }} {{ user.lastName }}</h2>
    </div>
    <button
      mat-icon-button
      [matMenuTriggerFor]="nameMenu"
      class="edit-icon-header"
    >
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #nameMenu="matMenu">
      <button
        mat-menu-item
        (click)="openEdit('Namen', ['firstName', 'lastName'])"
      >
        <mat-icon>edit</mat-icon>
        <span>Bearbeiten</span>
      </button>
      <button mat-menu-item (click)="deleteUser()">
        <mat-icon>delete</mat-icon>
        <span>Kontakt löschen</span>
      </button>
    </mat-menu>
  </mat-card-content>
</mat-card>

<div class="content-section">
  <div class="left-column">
    <mat-card class="pos-rel">
      <mat-card-header>
        <mat-card-title>
          <h3>Telefonnummer</h3>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ user.phone }}</p>
        <button
          mat-icon-button
          class="edit-icon"
          (click)="openEdit('Telefonnummer', 'phone')"
        >
          <mat-icon>edit</mat-icon>
        </button>
      </mat-card-content>
    </mat-card>

    <mat-card class="pos-rel">
      <mat-card-header>
        <mat-card-title>
          <h3>E-Mail</h3>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ user.mail }}</p>
        <button
          mat-icon-button
          class="edit-icon"
          (click)="openEdit('E-Mail', 'mail')"
        >
          <mat-icon>edit</mat-icon>
        </button>
      </mat-card-content>
    </mat-card>

    <mat-card class="pos-rel">
      <mat-card-header>
        <mat-card-title>
          <h3>Notiz</h3>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <textarea
          matInput
          [(ngModel)]="user.notice"
          (blur)="saveNotice()"
          placeholder="Notiz eingeben..."
          rows="4"
        ></textarea>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="right-column">
    <mat-card class="pos-rel">
      <mat-card-header>
        <mat-card-title>
          <h3>Geburtstag</h3>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ user.birthDate | date : "dd.MM.yyyy" }}</p>
        <button
          mat-icon-button
          class="edit-icon"
          (click)="openEdit('Geburtstag', 'birthDate')"
        >
          <mat-icon>edit</mat-icon>
        </button>
      </mat-card-content>
    </mat-card>
    <mat-card class="pos-rel">
      <mat-card-header>
        <mat-card-title>
          <h3>Anschrift</h3>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ user.street }}</p>
        <p>{{ user.zipCode }} {{ user.city }}</p>
        <button
          mat-icon-button
          class="edit-icon"
          (click)="openEdit('Adresse', ['street', 'zipCode', 'city'])"
        >
          <mat-icon>edit</mat-icon>
        </button>
      </mat-card-content>
    </mat-card>
    <mat-card class="pos-rel">
      <mat-card-header>
        <mat-card-title>
          <h3>Termin</h3>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ user.date | date : "dd.MM.yyyy, HH:mm" }}</p>
        <button
          mat-icon-button
          class="edit-icon"
          (click)="openEdit('Termin', 'date')"
        >
          <mat-icon>edit</mat-icon>
        </button>
      </mat-card-content>
    </mat-card>
  </div>
</div>
